export default "__VITE_ASSET__e3351a0b__"